<div class="container-fluid">
  <app-pagetitle
    title="Audit Logs"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>

  <!-- Filters Row -->
  <div class="row">
    <div class="col-xl-12">
      <div class="row">

        <!-- Customer Dropdown -->
        <div class="col-md-2">
          <div class="form-group">
            <label>Customer</label>
            <select
              class="form-control"
              [(ngModel)]="selectedCustomer"
              (ngModelChange)="onCustomerChange($event)"
            >
              <option *ngFor="let cust of customerList" [ngValue]="cust">
                {{ cust.custName }}
              </option>
            </select>
          </div>
        </div>

        <!-- From Date -->
        <div class="col-md-2" *ngIf="customerList.length">
          <div class="form-group">
            <label>From Date</label>
            <input
              class="form-control"
              type="date"
              [(ngModel)]="fromDate"
              [max]="maxDate"
            />
          </div>
        </div>

        <!-- To Date -->
        <div class="col-md-2" *ngIf="customerList.length">
          <div class="form-group">
            <label>To Date</label>
            <input
              class="form-control"
              type="date"
              [(ngModel)]="toDate"
              [min]="fromDate"
              [max]="maxDate"
            />
          </div>
        </div>

        <!-- Submit -->
        <div class="col-md-1">
          <button
            class="btn btn-success btn-rounded w-100"
            style="margin-top: 1.8rem"
            (click)="getLogs()"
          >
            Submit
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- Table Section -->
  <div class="row mt-3">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">

          <div class="table-responsive">

            <!-- No Data UI -->
            <div *ngIf="!logColumns.length || !filteredRows.length"
                 class="text-center text-muted py-4">
              <h6>No Data Found</h6>
            </div>

            <!-- Data Table -->
            <table *ngIf="logColumns.length && filteredRows.length"
              class="table table-striped table-bordered table-centered nowrap mb-0">

              <thead class="table-dark">
                <tr>
                  <th *ngFor="let col of logColumns">
                    <div class="d-flex justify-content-between align-items-center">
                      <span>{{ col | titlecase }}</span>

                      <!-- Filter Dropdown -->
                      <ng-container *ngIf="!noFilterColumns.includes(col.toLowerCase())">
                        <div ngbDropdown container="body"  class="btn-group" placement="bottom-right">
                          <i class="mdi mdi-filter cursor-pointer" ngbDropdownToggle></i>

                          <div ngbDropdownMenu>

                            <button class="dropdown-item"
                                    (click)="setFilter(col, '')">
                              All
                            </button>

                            <button class="dropdown-item"
                                    *ngFor="let opt of columnOptions[col]"
                                    (click)="setFilter(col, opt)">
                              {{ opt }}
                            </button>

                          </div>
                        </div>
                      </ng-container>

                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  *ngFor="let row of filteredRows | slice : (currentPage - 1) * itemsPerPage : currentPage * itemsPerPage">
                  <td *ngFor="let col of logColumns">
                    {{ row[col] || '—' }}
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination -->
            <div class="col-md-6 mt-3" *ngIf="filteredRows.length > itemsPerPage">
              <ngb-pagination
                class="pagination-rounded"
                [(page)]="currentPage"
                [collectionSize]="filteredRows.length"
                [pageSize]="itemsPerPage"
                [maxSize]="1"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
